import { Resident } from '@/types/resources/resident';
import { units } from '../resources/property';
import dayjs from 'dayjs';

// Celebrity names for residents
const celebrityNames = [
  'Tom Hanks', 'Julia Roberts', 'Brad Pitt', 'Angelina Jolie', 'Leonardo DiCaprio',
  'Jennifer Lawrence', 'Johnny Depp', 'Scarlett Johansson', 'Will Smith', 'Emma Stone',
  'Robert Downey Jr.', 'Meryl Streep', 'Denzel Washington', 'Sandra Bullock', 'Tom Cruise',
  'Nicole Kidman', 'George Clooney', 'Charlize Theron', 'Matt Damon', 'Cate Blanchett',
  'Ryan Reynolds', 'Blake Lively', 'Chris Hemsworth', 'Margot Robbie', 'Dwayne Johnson',
  'Gal Gadot', 'Hugh Jackman', 'Anne Hathaway', 'Daniel Radcliffe', 'Emma Watson',
  'Benedict Cumberbatch', 'Keira Knightley', 'Jake Gyllenhaal', 'Amy Adams', 'Chris Evans',
  'Mark Ruffalo', 'Jeremy Renner', 'Chris Pratt', 'Zoe Saldana', 'Vin Diesel', 'Paul Walker',
  'Michelle Rodriguez', 'Tyrese Gibson', 'Ludacris', 'Jason Statham', 'Kurt Russell', 'Helen Mirren',
  'Morgan Freeman', 'Al Pacino', 'Robert De Niro', 'Jack Nicholson', 'Diane Keaton',
  'Glenn Close', 'Judi Dench', 'Maggie Smith', 'Ian McKellen', 'Patrick Stewart',
  'Sean Connery', 'Pierce Brosnan', 'Daniel Craig', 'Harrison Ford', 'Mark Hamill',
  'Carrie Fisher', 'Billy Dee Williams', 'Anthony Daniels', 'Kenny Baker', 'Peter Mayhew',
  'David Prowse', 'James Earl Jones', 'Frank Oz', 'Alec Guinness', 'Peter Cushing',
  'Christopher Lee', 'Ian McDiarmid', 'Samuel L. Jackson', 'Natalie Portman', 'Ewan McGregor',
  'Liam Neeson', 'Hayden Christensen', 'Jake Lloyd', 'Ahmed Best', 'Ray Park',
  'Temuera Morrison', 'Daniel Logan', 'Orlando Bloom', 'Geoffrey Rush', 'Bill Nighy',
  'Stellan Skarsgård', 'Tom Hollander', 'Jack Davenport', 'Kevin McNally', 'Lee Arenberg',
  'Mackenzie Crook', 'Martin Freeman', 'Ian Holm', 'Elijah Wood', 'Sean Astin',
  'Dominic Monaghan', 'Billy Boyd', 'Viggo Mortensen', 'Sean Bean', 'John Rhys-Davies',
  'Liv Tyler', 'Hugo Weaving', 'Andy Serkis', 'Bernard Hill', 'David Wenham',
  'Karl Urban', 'Miranda Otto', 'Brad Dourif', 'John Noble', 'Bruce Spence',
  'Lawrence Makoare', 'Craig Parker', 'Harry Potter', 'Hermione Granger', 'Ron Weasley',
  'Albus Dumbledore', 'Severus Snape', 'Minerva McGonagall', 'Rubeus Hagrid', 'Sirius Black',
  'Remus Lupin', 'Nymphadora Tonks', 'Bellatrix Lestrange', 'Lucius Malfoy', 'Draco Malfoy',
  'Neville Longbottom', 'Luna Lovegood', 'Ginny Weasley', 'Fred Weasley', 'George Weasley',
  'Percy Weasley', 'Bill Weasley', 'Charlie Weasley', 'Arthur Weasley', 'Molly Weasley',
  'James Potter', 'Lily Potter', 'Petunia Dursley', 'Vernon Dursley', 'Dudley Dursley',
  'Albus Severus Potter', 'James Sirius Potter', 'Lily Luna Potter', 'Rose Weasley', 'Hugo Weasley',
  'Scorpius Malfoy', 'Teddy Lupin', 'Victoire Weasley', 'Dominique Weasley', 'Louis Weasley',
  'Roxanne Weasley', 'Molly Weasley II', 'Lucy Weasley', 'Fred Weasley II', 'George Weasley II'
];

export const residents: Resident[] = Array.from({ length: 150 }, (_, idx) => {
  // Use modulo to cycle through units, ensuring we don't exceed the units array
  const unit = units[idx % units.length];
  const celebrityName = celebrityNames[idx % celebrityNames.length];
  
  return {
    id: `RES-${(idx + 1).toString().padStart(3, '0')}`,
    user: {
      id: `user-res-${idx + 1}`,
      displayName: celebrityName,
      phoneNumber: `+55-11-${idx.toString().padStart(4, '0')}-${(idx + 1000).toString().padStart(4, '0')}`
    },
    type: idx % 3 === 0 ? 'owner' : idx % 3 === 1 ? 'tenant' : 'family_member',
    status: idx % 10 === 0 ? 'inactive' : 'active', // 10% inactive
    moveInDate: dayjs().subtract(Math.floor(Math.random() * 365), 'days').toDate(),
    moveOutDate: idx % 10 === 0 ? dayjs().subtract(Math.floor(Math.random() * 30), 'days').toDate() : undefined,
    apartmentUnit: { id: unit.id, number: unit.number },
    block: unit.block,
    documents: [],
    contacts: [
      {
        name: `Contato de Emergência para ${celebrityName}`,
        phone: `+55-11-${(idx + 1000).toString().padStart(4, '0')}-${(idx + 2000).toString().padStart(4, '0')}`,
        email: `emergencia.${celebrityName.toLowerCase().replace(' ', '.')}@demo.com`
      }
    ],
    notes: `Residente demo ${idx + 1} - ${celebrityName} morando em ${unit.block?.name} Unidade ${unit.number}`,
    workspace: unit.workspace,
    activityRecords: [{
      timestamp: dayjs().subtract(Math.floor(Math.random() * 30), 'days').toDate(),
      type: 'created',
      performedBy: { id: 'admin-001', displayName: 'Gerente de Propriedade' }
    }],
    violations: []
  };
});